<template>
    <v-card flat :theme="false" rounded="0" class="d-flex flex-column justify-center auth-login">
        <v-img :src="getImgUrl('background.jpg')" class="login-logo"></v-img>
        <v-card-item class="d-flex justify-center align-center h-100 pa-4">
            <v-card flat class="auth-login-card">
                <div class="text-center">
                    <img :src="getImgUrl('logo.png')" alt="logo" class="card-logo">
                </div>
                <v-card-title class="text-center">
                    <p class="mt-5 body-text-color primary-font-size">Change Password</p>
                </v-card-title>
                <v-card-text class="mt-5 pa-0">
                    <v-form v-model="valid">
                        <v-container>
                            <v-row>
                                <v-col cols="12" class="pa-0">
                                    <div class="login-form">
                                        <p class="bf600 body-text-color font-large-size pb-2">Current Password<span
                                                class="text-red">*</span></p>
                                        <v-text-field placeholder="Enter Current Password" :rules="rules" variant="outlined"
                                            density="compact" hide-details></v-text-field>
                                        <p class="bf600 body-text-color font-large-size pb-2 mt-5">New Password<span
                                                class="text-red">*</span></p>
                                        <v-text-field placeholder="Enter New Password" :rules="rules" variant="outlined"
                                            density="compact" hide-details></v-text-field>
                                        <p class="bf600 body-text-color font-large-size pb-2 mt-5">Confirm Password<span
                                                class="text-red">*</span></p>
                                        <v-text-field placeholder="Enter Confirm Password" :rules="rules" variant="outlined"
                                            density="compact" hide-details></v-text-field>
                                        <v-btn block class="btn bg-primary mt-5">
                                            Submit
                                        </v-btn>
                                        <div class="mt-5 text-center">
                                            <a href="javascript:void">
                                                <span>Back to LogOn</span>
                                            </a>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-card-item>
    </v-card>
</template>

<script setup>


let getImgUrl = (pic) => {
    return require("@/assets/image/" + pic);
};
</script>